function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState, useEffect } from 'react';
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, MenuItem, TextField, Chip } from '@mui/material';
import { ListAltOutlined as EditIcon, DeleteOutlined as DeleteIcon, Add } from '@mui/icons-material';
import { ConfigurationAPI } from '../apis';
import { CONFIGURATION_TYPES, CONFIGURATION_TYPE_LABELS } from '../constants/configuration';
import { constants } from '../constants';
import { AddConfigurationModal } from '../components/Configuration';
import { ConfirmationDialog } from '../components';
var ConfigurationPage = function ConfigurationPage() {
    var _configurationToDelet;
    var _useState = useState([]), _useState2 = _slicedToArray(_useState, 2), configurations = _useState2[0], setConfigurations = _useState2[1];
    var _useState3 = useState(true), _useState4 = _slicedToArray(_useState3, 2), loading = _useState4[0], setLoading = _useState4[1];
    var _useState5 = useState(''), _useState6 = _slicedToArray(_useState5, 2), selectedType = _useState6[0], setSelectedType = _useState6[1];
    var _useState7 = useState(false), _useState8 = _slicedToArray(_useState7, 2), modalOpen = _useState8[0], setModalOpen = _useState8[1];
    var _useState9 = useState(null), _useState0 = _slicedToArray(_useState9, 2), selectedConfiguration = _useState0[0], setSelectedConfiguration = _useState0[1];
    var _useState1 = useState(null), _useState10 = _slicedToArray(_useState1, 2), selectedItemIndex = _useState10[0], setSelectedItemIndex = _useState10[1];
    var _useState11 = useState(false), _useState12 = _slicedToArray(_useState11, 2), deleteDialogOpen = _useState12[0], setDeleteDialogOpen = _useState12[1];
    var _useState13 = useState(null), _useState14 = _slicedToArray(_useState13, 2), configurationToDelete = _useState14[0], setConfigurationToDelete = _useState14[1];
    var _useState15 = useState(null), _useState16 = _slicedToArray(_useState15, 2), itemIndexToDelete = _useState16[0], setItemIndexToDelete = _useState16[1];
    // Load configurations on component mount and when type filter changes
    useEffect(function () {
        loadConfigurations();
    }, [selectedType]);
    var loadConfigurations = /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
            var response, _t;
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.p = _context.n) {
                        case 0:
                            _context.p = 0;
                            setLoading(true);
                            _context.n = 1;
                            return ConfigurationAPI.getConfigurations(selectedType || undefined);
                        case 1:
                            response = _context.v;
                            setConfigurations(response.resource || []);
                            _context.n = 3;
                            break;
                        case 2:
                            _context.p = 2;
                            _t = _context.v;
                            setConfigurations([]);
                        case 3:
                            _context.p = 3;
                            setLoading(false);
                            return _context.f(3);
                        case 4:
                            return _context.a(2);
                    }
            }, _callee, null, [[0, 2, 3, 4]]);
        }));
        return function loadConfigurations() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAddConfiguration = function handleAddConfiguration() {
        setSelectedConfiguration(null); // Reset for add mode
        setSelectedItemIndex(null);
        setModalOpen(true);
    };
    var handleEditConfiguration = function handleEditConfiguration(configuration, itemIndex) {
        setSelectedConfiguration(configuration);
        setSelectedItemIndex(itemIndex);
        setModalOpen(true);
    };
    var handleDeleteConfiguration = function handleDeleteConfiguration(configuration, itemIndex) {
        setConfigurationToDelete(configuration);
        setItemIndexToDelete(itemIndex);
        setDeleteDialogOpen(true);
    };
    var confirmDeleteConfiguration = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
            var updatedItems, _t2;
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.p = _context2.n) {
                        case 0:
                            if (!(!configurationToDelete || itemIndexToDelete === null)) {
                                _context2.n = 1;
                                break;
                            }
                            return _context2.a(2);
                        case 1:
                            _context2.p = 1;
                            if (!(configurationToDelete.items.length === 1)) {
                                _context2.n = 3;
                                break;
                            }
                            _context2.n = 2;
                            return ConfigurationAPI.deleteConfiguration(configurationToDelete.id);
                        case 2:
                            _context2.n = 4;
                            break;
                        case 3:
                            // Remove the specific item and update configuration
                            updatedItems = configurationToDelete.items.filter(function (_, index) {
                                return index !== itemIndexToDelete;
                            });
                            _context2.n = 4;
                            return ConfigurationAPI.updateConfiguration(configurationToDelete.id, {
                                resourceType: 'Configuration',
                                type: configurationToDelete.type,
                                items: updatedItems,
                                details: configurationToDelete.details || {}
                            });
                        case 4:
                            _context2.n = 5;
                            return loadConfigurations();
                        case 5:
                            // Reload the list
                            setDeleteDialogOpen(false);
                            setConfigurationToDelete(null);
                            setItemIndexToDelete(null);
                            _context2.n = 7;
                            break;
                        case 6:
                            _context2.p = 6;
                            _t2 = _context2.v;
                        case 7:
                            return _context2.a(2);
                    }
            }, _callee2, null, [[1, 6]]);
        }));
        return function confirmDeleteConfiguration() {
            return _ref2.apply(this, arguments);
        };
    }();
    var handleConfigurationSaved = function handleConfigurationSaved() {
        // Reload configurations after add/edit
        loadConfigurations();
        setModalOpen(false);
        setSelectedConfiguration(null);
        setSelectedItemIndex(null);
    };
    var getTypeChipColor = function getTypeChipColor(type) {
        switch (type) {
            case CONFIGURATION_TYPES.SYSTEM:
                return 'secondary';
            case CONFIGURATION_TYPES.USER_EXPERIENCE:
                return 'primary';
            default:
                return 'default';
        }
    };
    var getValueTypeLabel = function getValueTypeLabel(value) {
        if (typeof value === 'string') {
            return constants.configuration_value_type_text;
        }
        if (typeof value === 'number') {
            return constants.configuration_value_type_number;
        }
        if (typeof value === 'boolean') {
            return constants.configuration_value_type_boolean;
        }
        return constants.configuration_value_type_json_object;
    };
    var renderLoadingRow = function renderLoadingRow() {
        return /*#__PURE__*/ React.createElement(TableRow, null, /*#__PURE__*/ React.createElement(TableCell, {
            colSpan: 4,
            sx: {
                textAlign: 'center',
                py: 4
            }
        }, constants.configuration_loading));
    };
    var renderEmptyRow = function renderEmptyRow() {
        return /*#__PURE__*/ React.createElement(TableRow, null, /*#__PURE__*/ React.createElement(TableCell, {
            colSpan: 4,
            sx: {
                textAlign: 'center',
                py: 4
            }
        }, constants.configuration_empty));
    };
    var renderEditAction = function renderEditAction(config, itemIndex) {
        return /*#__PURE__*/ React.createElement(IconButton, {
            onClick: function onClick() {
                return handleEditConfiguration(config, itemIndex);
            },
            sx: {
                color: '#26890d',
                '&:hover': {
                    bgcolor: 'rgba(38, 137, 13, 0.04)'
                }
            }
        }, /*#__PURE__*/ React.createElement(EditIcon, null));
    };
    var renderDeleteAction = function renderDeleteAction(config, itemIndex) {
        return /*#__PURE__*/ React.createElement(IconButton, {
            onClick: function onClick() {
                return handleDeleteConfiguration(config, itemIndex);
            },
            sx: {
                color: '#da291c',
                '&:hover': {
                    bgcolor: 'rgba(218, 41, 28, 0.04)'
                }
            }
        }, /*#__PURE__*/ React.createElement(DeleteIcon, null));
    };
    var renderTableBody = function renderTableBody() {
        if (loading) {
            return renderLoadingRow();
        }
        if (configurations.length === 0) {
            return renderEmptyRow();
        }
        return configurations.flatMap(function (config) {
            return config.items.map(function (item, index) {
                return /*#__PURE__*/ React.createElement(TableRow, {
                    key: "".concat(config.id, "-").concat(index),
                    sx: {
                        '&:hover': {
                            backgroundColor: '#f5f5f5'
                        },
                        borderBottom: '1px solid #ebebeb'
                    }
                }, /*#__PURE__*/ React.createElement(TableCell, {
                    sx: {
                        borderBottom: '1px solid #ebebeb',
                        py: 2
                    }
                }, item.key, index === 0 && /*#__PURE__*/ React.createElement(Chip, {
                    label: CONFIGURATION_TYPE_LABELS[config.type],
                    size: "small",
                    color: getTypeChipColor(config.type),
                    sx: {
                        ml: 1,
                        fontSize: '11px'
                    }
                })), /*#__PURE__*/ React.createElement(TableCell, {
                    sx: {
                        borderBottom: '1px solid #ebebeb',
                        py: 2
                    }
                }, _typeof(item.value) === 'object' ? JSON.stringify(item.value) : String(item.value)), /*#__PURE__*/ React.createElement(TableCell, {
                    sx: {
                        borderBottom: '1px solid #ebebeb',
                        py: 2
                    }
                }, getValueTypeLabel(item.value)), /*#__PURE__*/ React.createElement(TableCell, {
                    sx: {
                        borderBottom: '1px solid #ebebeb',
                        py: 2
                    }
                }, /*#__PURE__*/ React.createElement(Box, {
                    sx: {
                        display: 'flex',
                        gap: 1
                    }
                }, renderEditAction(config, index), renderDeleteAction(config, index))));
            });
        });
    };
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            p: 3
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 2
        }
    }, /*#__PURE__*/ React.createElement(TextField, {
        select: true,
        label: constants.configuration_type_system,
        value: selectedType,
        onChange: function onChange(e) {
            return setSelectedType(e.target.value);
        },
        sx: {
            minWidth: 200
        },
        size: "small"
    }, /*#__PURE__*/ React.createElement(MenuItem, {
        value: ""
    }, constants.configuration_filter_all_types), Object.entries(CONFIGURATION_TYPE_LABELS).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2), typeKey = _ref4[0], label = _ref4[1];
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: typeKey,
            value: typeKey
        }, label);
    }))), /*#__PURE__*/ React.createElement(Button, {
        variant: "contained",
        startIcon: /*#__PURE__*/ React.createElement(Add, null),
        onClick: handleAddConfiguration,
        sx: {
            backgroundColor: '#26890D',
            '&:hover': {
                backgroundColor: '#1e6b0a'
            }
        }
    }, constants.configuration_add_button)), /*#__PURE__*/ React.createElement(TableContainer, {
        component: Paper,
        sx: {
            borderRadius: 2,
            border: '1px solid #ebebeb',
            width: '100%',
            overflowX: 'auto',
            boxSizing: 'border-box',
            minWidth: 600
        }
    }, /*#__PURE__*/ React.createElement(Table, {
        sx: {
            minWidth: 800,
            tableLayout: 'auto'
        }
    }, /*#__PURE__*/ React.createElement(TableHead, null, /*#__PURE__*/ React.createElement(TableRow, {
        sx: {
            backgroundColor: '#fff'
        }
    }, /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            fontWeight: 600,
            borderBottom: '1px solid #ebebeb',
            color: '#212121',
            whiteSpace: 'nowrap',
            minWidth: 320,
            maxWidth: 400,
            wordBreak: 'break-all'
        }
    }, constants.configuration_table_header_key), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            fontWeight: 600,
            borderBottom: '1px solid #ebebeb',
            color: '#212121',
            minWidth: 300,
            wordBreak: 'break-all',
            whiteSpace: 'pre-line'
        }
    }, constants.configuration_table_header_value), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            fontWeight: 600,
            borderBottom: '1px solid #ebebeb',
            color: '#212121',
            minWidth: 160,
            whiteSpace: 'nowrap'
        }
    }, constants.configuration_table_header_type_of_value), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            fontWeight: 600,
            borderBottom: '1px solid #ebebeb',
            width: 120,
            color: '#212121',
            whiteSpace: 'nowrap'
        }
    }, constants.configuration_table_header_actions))), /*#__PURE__*/ React.createElement(TableBody, null, renderTableBody()))), /*#__PURE__*/ React.createElement(AddConfigurationModal, {
        open: modalOpen,
        onClose: function onClose() {
            setModalOpen(false);
            setSelectedConfiguration(null);
            setSelectedItemIndex(null);
        },
        onSaved: handleConfigurationSaved,
        configuration: selectedConfiguration,
        itemIndex: selectedItemIndex,
        existingConfigurations: configurations
    }), /*#__PURE__*/ React.createElement(ConfirmationDialog, {
        isOpen: deleteDialogOpen,
        bodyText: constants.configuration_delete_confirm_body(configurationToDelete && itemIndexToDelete !== null ? ((_configurationToDelet = configurationToDelete.items[itemIndexToDelete]) === null || _configurationToDelet === void 0 ? void 0 : _configurationToDelet.key) || '' : ''),
        submitButtonText: constants["delete"],
        actionType: "delete",
        submitFunction: confirmDeleteConfiguration,
        setIsOpen: setDeleteDialogOpen
    }));
};
export default ConfigurationPage;
